import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorMapFieldCropControlComponent } from './field-editor-map-field-crop-control.component';
import {
  DxButtonModule,
  DxFormModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxPopoverModule,
  DxPopupModule,
  DxToolbarModule
} from 'devextreme-angular';
import { IconModule } from '@visurel/iconify-angular';
import { CropSelectorModule } from '../../crops/crop-selector/crop-selector.module';
import { CropsGridModule } from '../../crops/crops-grid/crops-grid.module';
import { CampaignSelectorModule } from '../../campaign/campaign-selector/campaign-selector.module';



@NgModule({
  declarations: [FieldEditorMapFieldCropControlComponent],
  imports: [
    CommonModule,
    DxToolbarModule,
    IconModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxPopoverModule,
    DxFormModule,
    CropSelectorModule,
    DxPopupModule,
    CropsGridModule,
    CampaignSelectorModule
  ],
  exports: [FieldEditorMapFieldCropControlComponent]
})
export class FieldEditorMapFieldCropControlModule { }
